// Geteilte Konstanten und Helper rund um Kontakte.

export const ANREDE_OPTIONS = [
  { value: 'herr', label: 'Herr' },
  { value: 'frau', label: 'Frau' },
];

export const ANREDE_LABEL = {
  herr: 'Herr',
  frau: 'Frau',
};

/**
 * Funktion des Kontakts in der Praxis. Die zulässigen Werte spiegeln das
 * select-Feld "rolle" der kontakte-Collection — neue Optionen brauchen
 * IMMER eine Migration, sonst weist PocketBase das Speichern ab
 * (siehe 1744300035_kontakte_rollen_erweitern.js).
 *
 * Reihenfolge: medizinische Rollen zuerst, dann kaufmännische/organisatorische.
 */
export const ROLLE_OPTIONS = [
  { value: 'arzt', label: 'Arzt / Ärztin' },
  { value: 'inhaber', label: 'Inhaber:in' },
  { value: 'gf', label: 'GF' },
  { value: 'gesellschafter', label: 'Gesellschafter' },
  { value: 'praxismanager', label: 'Praxis-Manager' },
  { value: 'abrechnungsleiter', label: 'Abrechnungsleitung' },
  { value: 'mitarbeiter', label: 'Mitarbeiter:in' },
];

export const ROLLE_LABEL = Object.fromEntries(
  ROLLE_OPTIONS.map((o) => [o.value, o.label])
);

/**
 * Anzeigename einer Rolle. Fällt auf den Rohwert zurück, damit ein noch
 * nicht gepflegter Wert sichtbar bleibt statt als leere Zelle zu erscheinen.
 */
export function rolleAnzeige(rolle) {
  return ROLLE_LABEL[rolle] ?? rolle ?? '—';
}

/**
 * Setzt den anzuzeigenden Kontakt-Namen aus Anrede, Titel, Vorname und
 * Nachname zusammen — leere Bestandteile werden rausgefiltert, damit
 * Altbestand ohne Anrede sauber als "Dr. Max Mustermann" erscheint und
 * nicht als "undefined Dr. Max Mustermann".
 */
export function formatKontaktName(kontakt) {
  if (!kontakt) return '';
  const parts = [
    kontakt.anrede ? ANREDE_LABEL[kontakt.anrede] : null,
    kontakt.titel || null,
    kontakt.vorname || null,
    kontakt.nachname || null,
  ].filter(Boolean);
  return parts.join(' ').trim();
}
